// extracted by mini-css-extract-plugin
export default {"text":"PomodoroText_text__QrYWk"};